import { Link } from "react-router-dom";

const NotFound = () => {
    return (
        <div className="text-center m-10">
            <h2 className="text-5xl mb-4">Evento no encontrado</h2>
            <p className="text-lg mb-3">
                El evento que buscas no existe o ha sido eliminado.
            </p>
            <div className="mt-6">
                <Link
                    to="/eventos"
                    className="text-rose-200 bg-rose-950 p-3 rounded-lg"
                >
                    Volver a eventos
                </Link>
            </div>
        </div>
    );
};

export default NotFound;
